// DS3.10, DS3.10M
// Note that DS3.10M is achieved using `layout='vertical'`
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import isEqual from 'lodash/isEqual';
import VerticalLayout from './layouts/VerticalLayout';
import HorizontalLayout from './layouts/HorizontalLayout';
import LargeInputFieldButton from './lego/LargeInputFieldButton';
import ClearButton from './lego/ClearButton';
import LargeInputField from './lego/LargeInputField';
function getRootLayoutComponent(layout) {
    switch(layout){
        case 'horizontal':
            return HorizontalLayout;
        case 'vertical':
        default:
            return VerticalLayout;
    }
}
/**
 * An input field with a button. This provides both horizontal and vertical layouts.
 */ const LargeInputFieldWithButton = (_param)=>{
    var { value, layout, onClear, className, buttonProps } = _param, rest = _object_without_properties(_param, [
        "value",
        "layout",
        "onClear",
        "className",
        "buttonProps"
    ]);
    const RootLayout = getRootLayoutComponent(layout);
    return /*#__PURE__*/ React.createElement(RootLayout, {
        className: className
    }, /*#__PURE__*/ React.createElement(LargeInputField, _object_spread({
        isPostfixed: layout === 'horizontal',
        value: value,
        postfix: value && onClear && /*#__PURE__*/ React.createElement(ClearButton, {
            onClick: onClear
        })
    }, rest)), /*#__PURE__*/ React.createElement(LargeInputFieldButton, _object_spread({
        isPostfix: layout === 'horizontal'
    }, buttonProps)));
};
LargeInputFieldWithButton.displayName = 'LargeInputField';
// Since we accept a `buttonProps` object, running the passed props through lodash's `isEqual` function.
// That should cut down on unnecessary rerenders.
export default /*#__PURE__*/ React.memo(LargeInputFieldWithButton, isEqual);

//# sourceMappingURL=LargeInputFieldWithButton.js.map